<template>
  <div class="topbar van-swipe" :class="{isDevop:bannerType==1,isOperate:bannerType==2,isBuild:bannerType==3,isHealth:bannerType==4,hasBorder:hasBorder}">
    <div class="content"> 
      <div class="year">{{custom.yearcontent}}</div>
      <div class="topname">{{custom.name}}</div>
    </div>
    <div class="number">
      <div class="numlayout">{{custom.number}} </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      isOperate:true,
      isDevop:false,
      isBuild:false,
      operateContent1:'2019年商业地产行业',
      operateContent2:'绿色运营指数',
      operateNum:'61' //2019年房地产行业   绿色开发指数
    }
  },
  props: ['bannerType','custom','hasBorder'],
  created() {
  }
}
</script>

<style  lang="stylus" scoped>
.topbar{
  width: 690px;
  margin: 0 auto;
  height:140px;
  border-radius:20px 20px 0 0;
  display: flex;
  align-items: center;
  justify-content:center;
  .content{
    text-align: right;
    color:#000
    .year{
      font-size:30px;
      padding: 5px;
    }
    .topname{
      padding: 5px;
      font-size:30px;
      font-weight:bold
    }
  }
  .number{
    .numlayout{
      height: 70px;
      background-color: #fff;
      border-radius: 10px;
      line-height: 70px;
      text-align: center;
      font-size: 45px;
      margin-left 60px;
      font-weight: bold;
      padding: 0 20px;
      box-shadow: 0px 1px 10px 0px rgba(22, 22, 22, 0.35);
    }
  }
}
.isOperate{
  // background-color:#AAD64A;
  background-image: linear-gradient(to right, #e7f3be, #aed02e);
  .number{
    color #83db25
  }
}
.isDevop{
  // background-color:#9DC3E6;
  background-image: linear-gradient(to right, #d7f2fc, #8dd2ec);
  .number{
    color #7db8eb
  }
}
.isBuild{
  // background-color:#D9C9ED;
  background-image: linear-gradient(to right, #f9f8c5, #f6d62e);
  .number{
    color #e5a904
  }
}
.isHealth{
  background-image: linear-gradient(to right, #f0e6be, #b29449);
  .number{
    color #b17d2d
  }
}
.hasBorder{
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  margin-bottom: 0;
}
</style>